// Load Book List
export const START_LOAD_BOOK_LIST = 'START_LOAD_BOOK_LIST';
export const LOAD_BOOK_LIST_SUCCESS = 'LOAD_BOOK_LIST_SUCCESS';
export const LOAD_BOOK_LIST_FAILURE = 'LOAD_BOOK_LIST_FAILURE';
export const INIT_LOAD_BOOK_LIST_ACTION_STATUS = 'INIT_LOAD_BOOK_LIST_ACTION_STATUS';